import { StatusCodes } from "http-status-codes";
import { backendHostName } from "@/utils/constants";

export const fetchApi = async <T>(
  url: string,
  options: RequestInit,
): Promise<T> => {
  const request = new Request(`${backendHostName}${url}`, options);
  const response = await fetch(request);

  if (response.status >= StatusCodes.BAD_REQUEST) {
    throw new Error(`Unexpected response code ${response.status}`);
  }

  if (response.status === StatusCodes.NO_CONTENT) {
    return undefined as T;
  }

  return (await response.json()) as T;
};
